"use strict";
/**
 * @module Services.FetchQuery
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type contained in the {@link FetchQueryResult} response.
 */
var FetchTopicResult = /** @class */ (function () {
    /**
     * Create a new FetchTopicResult instance
     *
     * @param path  the topic path
     * @param type  the topic type
     * @param value  the value of the topic in case it was requested
     * @param propertiesIndex  the properties index
     */
    function FetchTopicResult(path, type, propertiesIndex, value) {
        this.path = path;
        this.type = type;
        this.value = value;
        this.propertiesIndex = propertiesIndex;
    }
    return FetchTopicResult;
}());
exports.FetchTopicResult = FetchTopicResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/fetch-query/fetch-topic-result.js
// module id = 1302
// module chunks = 1